import { render, staticRenderFns } from "./textRow.vue?vue&type=template&id=1d4832d5&scoped=true&"
import script from "./textRow.vue?vue&type=script&lang=js&"
export * from "./textRow.vue?vue&type=script&lang=js&"
import style0 from "./textRow.vue?vue&type=style&index=0&id=1d4832d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4832d5",
  null
  
)

export default component.exports